import type { RadioConfig } from '#types/config/components/vf/radio'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    control: {
      shared: 'p-1 h-6 w-6',
      variant: {
        base: {
          default: 'ring-grey-40',
          disabled: 'bg-grey-80 ring-grey-50',
          disabledSelected: 'bg-grey-80 ring-grey-50 c-grey-50',
          error: 'ring-red-30',
          selected: 'ring-grey-40 c-grey-10'
        },
        inverse: {
          default: 'ring-grey-60',
          disabled: 'bg-grey-20 ring-grey-50',
          disabledSelected: 'bg-grey-20 ring-grey-50 c-grey-50',
          error: 'ring-red-60',
          selected: 'ring-grey-60 c-grey-90'
        }
      }
    },
    label: {
      shared: 'text-base',
      variant: {
        base: {
          default: 'c-grey-10',
          disabled: 'c-grey-30'
        },
        inverse: {
          default: 'c-white',
          disabled: 'c-grey-60'
        }
      }
    },
    wrapper: {
      shared: 'gap-x-4 items-center'
    }
  }
} satisfies RecursivePartial<RadioConfig>
